var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from "react";
import { commerce } from "../../../lib/commerce";
import { CircularProgress, CssBaseline, Divider, Button, Paper, Step, StepLabel, Stepper, Typography, Box, Container, useTheme, } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import AddressForm from "../AddressForm";
import PaymentForm from "../PaymentForm";
import styles from "./styles";
import { createShippingData } from "@/lib/functions/factory";
var steps = ["Shipping address", "Payment details"];
var Checkout = function (_a) {
    var cart = _a.cart, order = _a.order, onCaptureCheckout = _a.onCaptureCheckout, error = _a.error, handleEmptyCart = _a.handleEmptyCart;
    var _b = useState(0), activeStep = _b[0], setActiveStep = _b[1];
    var _c = useState(undefined), checkoutToken = _c[0], setCheckoutToken = _c[1];
    var _d = useState(createShippingData), shippingData = _d[0], setShippingData = _d[1];
    var _e = useState(false), isFinished = _e[0], setIsFinished = _e[1];
    var Navigate = useNavigate();
    var theme = useTheme();
    var classes = styles(theme);
    var nextStep = function () { return setActiveStep(function (prevActiveStep) { return prevActiveStep + 1; }); };
    var prevStep = function () { return setActiveStep(function (prevActiveStep) { return prevActiveStep - 1; }); };
    useEffect(function () {
        var generateToken = function () { return __awaiter(void 0, void 0, void 0, function () {
            var token, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!(cart.total_items > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, commerce.checkout.generateToken(cart.id, {
                                type: "cart",
                            })];
                    case 1:
                        token = _a.sent();
                        setCheckoutToken(token);
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        Navigate("/");
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        generateToken();
    }, [cart]);
    useEffect(function () {
        if (isFinished) {
            handleEmptyCart();
        }
    }, [isFinished, handleEmptyCart]);
    var next = function (data) {
        setShippingData(data);
        nextStep();
    };
    var Confirmation = function () {
        return order.customer ? (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement(Typography, { variant: "h5" },
                    "Thank you for your purchase, ",
                    order.customer.firstname,
                    ",",
                    " ",
                    order.customer.lastname,
                    ". You will receive a confirmation email shortly."),
                React.createElement(Divider, { sx: classes.divider }),
                React.createElement(Typography, { variant: "subtitle2" },
                    "Order ref: ",
                    order.customer_reference)),
            React.createElement("br", null),
            React.createElement(Button, { component: Link, to: "/", variant: "outlined", type: "button" }, "Back To Home"))) : isFinished ? (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement(Typography, { variant: "h5" }, "Thank you for your purchase. You will receive a confirmation email shortly."),
                React.createElement(Divider, { sx: classes.divider })),
            React.createElement("br", null),
            React.createElement(Button, { component: Link, to: "/", variant: "outlined", type: "button" }, "Back To Home"))) : (React.createElement(Box, { sx: classes.spinner },
            React.createElement(CircularProgress, null)));
    };
    if (error) {
        React.createElement(React.Fragment, null,
            React.createElement(Typography, { variant: "h5" },
                "Error: ",
                error,
                " "),
            React.createElement("br", null),
            React.createElement(Button, { component: Link, to: "/", variant: "outlined", type: "button" }, "Back To Home"));
    }
    var Form = function () {
        return activeStep === 0 ? (React.createElement(AddressForm, { checkoutToken: checkoutToken, next: next })) : (React.createElement(PaymentForm, { checkoutToken: checkoutToken, shippingData: shippingData, prevStep: prevStep, onCaptureCheckout: onCaptureCheckout, nextStep: nextStep, timeout: timeout }));
    };
    var timeout = function () {
        setTimeout(function () {
            setIsFinished(true);
        }, 3000);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(CssBaseline, null),
        React.createElement(Box, { sx: classes.toolbar }),
        React.createElement(Container, { sx: classes.layout },
            React.createElement(Paper, { sx: classes.paper },
                React.createElement(Typography, { variant: "h4", align: "center" }, "Checkout"),
                React.createElement(Stepper, { activeStep: activeStep, sx: classes.stepper }, steps.map(function (step) { return (React.createElement(Step, { key: step },
                    React.createElement(StepLabel, null, step))); })),
                activeStep === steps.length ? (React.createElement(Confirmation, null)) : (checkoutToken && React.createElement(Form, null))))));
};
export default Checkout;
